<template>
  <div>  
    <el-dialog
      title="Emitir Etiqueta"
      :visible.sync="dialogVisible"
      width="40%"
      center
    >
      <el-form :model="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Código de Rastreio">
                <el-input v-model="form.track" placeholder="Digite o número" @keydown.enter.native.prevent="printAll"></el-input>
              </el-form-item>
            </el-col>
          </el-row> 
      </el-form> 
      
      <!-- FORMA DE IMPRESSÃO teste -->
      <el-row :gutter="20" style="margin-top: 35px;">
        <el-form>
          <el-form-item>
            <el-radio v-model="print.model" label="0">Zebra<br /> <img src='/img/zebra4x1.png'
                style="margin-left: 23px" /></el-radio>
            <el-radio v-model="print.model" label="1">1 por folha<br /> <img src='/img/etiqueta4x1.png'
                style="margin-left: 28px" /></el-radio>
            <el-radio v-model="print.model" label="2">2 por folha<br /> <img src='/img/etiqueta4x2.png'
                style="margin-left: 28px" /></el-radio>
            <el-radio v-model="print.model" label="4">4 por folha<br /> <img src='/img/etiqueta4x4.png'
                style="margin-left: 28px" /></el-radio>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="print.warning" autocomplete="off">Imprimir Aviso Recebimento</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="print.declared" autocomplete="off">Imprimir Declaração Conteudo</el-checkbox>
            <el-radio :disabled="!print.declared" v-model="print.type" label="1">Para todas as etiquetas</el-radio>
            <el-radio :disabled="!print.declared" v-model="print.type" label="2">Somente que possuem declaração</el-radio>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="print.separator" autocomplete="off">Arquivos separados</el-checkbox>
          </el-form-item>
        </el-form>
      </el-row> 

      <el-row :gutter="20">
        <el-button type="primary" @click="printAll" style="margin-top: 25px; margin-left: 10px; width: 20%">Buscar</el-button>
      </el-row> 

      <!-- TELA DE IMPRESSÃO -->
      <el-card shadow="never" style="margin-top: 20px;">
        <el-tabs type="card" v-model="printerTab">
          <el-tab-pane name="proof" label="Comprovante">
            <iframe
              :src="pdf.proof"
              style="width: 100%; height: 400px; border: none"
            ></iframe>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" >Sair</el-button>
      </span>
    </el-dialog>
    <el-aside :width="size" class="aside" :class="{ 'aside--open': mobileOpen }" @mouseleave.native="hide">
    <el-menu default-active="1-1" class="el-menu-vertical-demo"
      :collapse="collapse">
      <el-button type="text" style="margin-bottom: 5px; margin-top: 3px; margin-left: 10px;  color: #999999" icon="el-icon-s-grid"
      @click="collapse = !collapse" circle></el-button>
      <el-menu-item index="1-1" class="custom-menu-item" @click="redirect('/servicos/calculadora')">
        <i class="fa fa-calculator"></i>
        <span slot="title">Calculadora Frete</span>
      </el-menu-item>
      <!--<el-menu-item v-if="userType == '1' || customer === '14b1afaa-fb01-4480-9121-102572395bb6' || customer === '31388f7a-ffc6-455b-8c20-2b2f9aaa90df' || customer === 'd36da0c7-f252-4af1-82ec-22aebd93cce4' || customer === 'ea3f8b43-953c-4a85-bb5b-57ee13487666' || customer === 'f1b52f89-42fd-4f8e-b1e9-d49b05bcf65f' || customer === '97a7b354-d551-47fc-9960-d55294acc74d' || customer === '755f04a3-abf5-4df1-aa82-5c7d8ce87a94' || customer === 'c55344b9-1cb9-40a1-973f-ff1a3d7a9e3e'"  index="1-2" class="custom-menu-item" @click="redirect('/servicos/motoboy')">
        <i class="fa fa-motorcycle" aria-hidden="true"></i>
        <span slot="title">Solicitar Motoboy</span>
      </el-menu-item>-->
      <el-menu-item v-if="pdv"  index="1-3" class="custom-menu-item" @click="dialogVisible = true">
        <i class="fa fa-file-text" aria-hidden="true"></i>
        <span slot="title">Etiqueta Parceiro</span>
      </el-menu-item>
      <!--el-menu-item index="1-2" class="custom-menu-item">
        <i class="fa fa-search"></i>
        <span slot="title">Pesquisar Etiqueta</span>
      </el-menu-item>
      <el-menu-item index="1-3" class="custom-menu-item" @click="goto">
        <i class="fa" :class="{'fa-shake': notification, 'blue': notification, 'fa-bell-o': !notification, 'fa-bell': notification }"></i>
        <span slot="title">Mensagens<span class="text-bg-secondary bg-primary">{{ total }}</span></span>
      </el-menu-item>
      <el-menu-item index="1-4" class="custom-menu-item" @click="chat">
        <i class="fa fa-whatsapp" :class="{'fa-beat': whatsapp, 'green': whatsapp }"></i>
        <span slot="title">Notificações<span class="text-bg-secondary bg-indigo">{{ message }}</span></span>
      </el-menu-item -->
      <el-divider />
      <el-menu-item v-for="(row, index) of favorite" :index="`2-${index}`" :key="row.name" class="custom-menu-item" @click="redirect(row.path)">
        <i v-if="row.icon" :class="row.icon"></i><i v-else class="el-icon-tickets"></i>
        <span slot="title">{{ $t(row.name) }}</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
  </div>
  
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { PrepostService } from "@/services/customers/prepost.services";
import { PdvService } from "@/services/pdv/pdv.services";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("socket", ["socket"]),
  },
  data() {
    return {
      printDialog: true,
      printerTab: "proof",
      dialogVisible: false,
      pdv: false,
      form: {
        track: ''
      },
      print: {
        model: '4',
        warning: true,
        declared: true,
        type: '1',
        dialog: false,
        show: false,
        singleTag: '',
        separator: false,
      },
      favorite: [],
      collapse: true,
      mobileOpen: false,
      notification: false,
      whatsapp: false,
      userType: '2',
      total: 0,
      message: 0,
      customer: '',
      pdf: {
        proof: ''
      }
    };
  },
  computed: {
    size() {
      return this.collapse ? '63px' : '210px';
    }
  },
  methods: {
    async printAll(event) {
      const vm = this;
      let tag = [vm.form.track.toUpperCase().replace(/\s+/g, '')];

      try {
        const loading = vm.$loading(vm.$options.loading);

        console.log('Código de rastreio inserido: ', tag);

        if (tag.length === 0) {
          vm.$message({
            type: "warning",
            duration: 4000,
            message: "Nenhuma tag encontrada para impressão.",
          });
          return;
        }

        // Agora sim, imprime
        const pdfResponse = await PrepostService.print(tag, vm.print);
        vm.pdf.proof = pdfResponse;
        loading.close();
      } catch (error) {
        vm.$message({
          type: "error",
          duration: 5000,
          message: error.message || "Erro ao imprimir",
        });
      } finally {
        loading.close();
      }
    },
    hide() {
      this.collapse = true;
      this.mobileOpen = false;
    },
    chat() {
      this.hide();
      this.whatsapp = false;
      this.$emit('chat');
    },
    redirect(page) {
      this.hide();
      this.$router.push(page).catch(() => { });
    },
    received(total) {
      this.message = total;
      this.whatsapp = true;
    },
    setup() {
      const vm = this;
      vm.socket.on("newMessage", (data) => {
        vm.total += 1;
        vm.notification = true;
      });
      vm.socket.on("chat-operator", (data) => vm.received(data.length));
      vm.socket.on("chat-populate", (data) => vm.received(data.length));
      vm.socket.on("motoboy-add", (data) => vm.motoboy(data));
    },
    motoboy(data) {

    },
    goto() {
      this.hide();
      this.notification = false;
      this.$router.replace({ name: 'notification', params: { to: 'message' } }).catch(() => { });
    },
    resize() {
      this.collapse = !this.collapse;
      this.$emit("resize", this.collapse);
    },
    fetch: function () {
      const vm = this;
      UserService.menu()
        .then((response) => {
          vm.userType = response.user.type;
          vm.customer = response.user.customers ? response.user.customers.id : '';
          vm.favorite = response.user.menu.filter(x => x.favorite);
          vm.pdv = (response.user.type === '1' || response.user.type === '3' || response.user.pdv === true);
        })
        .catch((err) => {
        });
    },
  },
  mounted() {
    const vm = this;
    vm.$bus.$on("toggle-sidebar", () => {
      vm.mobileOpen = !vm.mobileOpen;
      vm.collapse = !vm.mobileOpen;
    });
    vm.$bus.$on("favoriteHandle", (row) => {
      console.log('favoriteHandle', row, row.favorite);
      if (!row.favorite) {
        vm.favorite.push(row);
      } else {
        const index = vm.favorite.findIndex(x => x.name === row.name);
        console.log('index', vm.favorite, index);
        if (index !== -1) {
          vm.favorite.splice(index, 1);
        }
      }
      console.log('favoriteHandle', row);
    });
    vm.fetch();

/*    const interval = setInterval(() => {
      if (vm.socket) {
        vm.setup();
        clearInterval(interval);
      }
    }, 1000);
*/
  },
};
</script>
<style>
.header-global {
  margin-bottom: 20px;
}
.el-menu-vertical-demo {
  min-height: 100%;
  text-align: center;
}
.fa {
  padding-left: 5px;
  padding-right: 8px;
}
/* Sidebar congelada: acompanha o scroll e vai até o rodapé.
   60px = altura do header fixo (.app-topbar em App.vue). */
.aside {
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  height: auto;
  z-index: 1500; /* abaixo da navbar (1600) e da camada de popups do Element (2000+) */
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  border-right: 1px solid var(--me-border-lighter);
  transition: width 0.2s ease, transform 0.25s ease, box-shadow 0.25s ease;
}

@media only screen and (max-width: 767px) {
  /* Off-canvas: só aparece quando acionada pelo hamburger do header */
  .aside {
    width: 210px !important;
    transform: translateX(-100%);
  }

  .aside.aside--open {
    transform: translateX(0);
    box-shadow: var(--me-shadow-lg);
  }
}
.custom-menu-item {
  text-align: left;
  height: 35px;
  line-height: 35px;
}
.text-bg-secondary {
  margin-left: 3px;
  color: #fff;
  text-align: right;
  padding: 4px;
  border-radius: 4px;
  font-size: 10px;
}
.bg-primary {
  background-color: var(--me-primary);
}
.bg-indigo {
  background-color: var(--indigo);
}
</style>

